module.exports = __webpack_public_path__ + "static/img/icon-six-step-5.46fae390.png";